import type { AppPageProps } from '@/types';
import { usePage } from '@inertiajs/vue3';
import { computed, ref, type ComputedRef } from 'vue';

// No router.reload() after OTP: the async hop breaks the file picker's user-gesture window, so this flag bridges the stale page props.
const loggedInLocally = ref<boolean>(false);

type AiCustomerAuthReturn = {
    isCustomerAuthenticated: ComputedRef<boolean>;
    markLoggedInLocally: () => void;
};

export function useAiCustomerAuth(): AiCustomerAuthReturn {
    const page = usePage<AppPageProps>();

    // Computed rather than a ref snapshot, so it keeps reading Inertia's reactive props live.
    const isCustomerAuthenticated = computed<boolean>(() => loggedInLocally.value || (page.props.magento_customer_auth?.is_authenticated ?? false));

    function markLoggedInLocally(): void {
        loggedInLocally.value = true;
    }

    return { isCustomerAuthenticated, markLoggedInLocally };
}
